export default {
  data() {
    return {
      // Current page index (1-based)
      currentPage: 1
    };
  },

  computed: {
    /**
     * Items to paginate.
     * Components should override this with a computed that returns the array
     * they want to paginate (e.g. matches, displayedContracts, normalizedMatches).
     */
    paginationItems() {
      return [];
    },

    /**
     * Effective page size for pagination.
     * Looks for common prop names (pageSize, itemsPerPage) and falls back to 10.
     * Kept separate from any component props named "pageSize" to avoid recursion.
     */
    effectivePageSize() {
      // Size of item shown on the page
      const sizeFromProps = this.pageSize || this.itemsPerPage;
      return sizeFromProps || 10;
    },

    totalPages() {
      const items = this.paginationItems || [];
      const size = this.effectivePageSize || 0;
      if (!items.length || !size) return 0;
      return Math.ceil(items.length / size);
    },

    showPagination() {
      const items = this.paginationItems || [];
      const size = this.effectivePageSize || 0;
      return items.length > size && size > 0;
    },

    canGoToPreviousPage() {
      return this.currentPage > 1;
    },

    canGoToNextPage() {
      return this.currentPage < this.totalPages;
    },

    paginatedItems() {
      const items = this.paginationItems || [];
      const size = this.effectivePageSize || 0;
      if (!items.length || !size) return [];
      const start = (this.currentPage - 1) * size;
      const end = start + size;
      return items.slice(start, end);
    },

    paginationStart() {
      const items = this.paginationItems || [];
      const size = this.effectivePageSize || 0;
      if (!items.length || !size) return 0;
      return (this.currentPage - 1) * size + 1;
    },

    paginationEnd() {
      const items = this.paginationItems || [];
      const size = this.effectivePageSize || 0;
      if (!items.length || !size) return 0;
      return Math.min(this.currentPage * size, items.length);
    },

    paginationText() {
      const items = this.paginationItems || [];
      if (!items.length) return '';
      return `Showing ${this.paginationStart} - ${this.paginationEnd} of ${items.length}`;
    }
  },

  watch: {
    // Reset to first page when the underlying items change
    paginationItems() {
      this.currentPage = 1;
    },
    // Also reset when page size changes
    effectivePageSize() {
      this.currentPage = 1;
    }
  },

  methods: {
    goToPreviousPage() {
      if (this.canGoToPreviousPage) {
        this.currentPage--;
      }
    },

    goToNextPage() {
      if (this.canGoToNextPage) {
        this.currentPage++;
      }
    }
  }
};

